import { render, staticRenderFns } from "./UGA.vue?vue&type=template&id=214b2140&scoped=true&"
import script from "./UGA.vue?vue&type=script&lang=js&"
export * from "./UGA.vue?vue&type=script&lang=js&"
import style0 from "./UGA.vue?vue&type=style&index=0&id=214b2140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214b2140",
  null
  
)

export default component.exports